import script from "./Client.vue?vue&type=script&setup=true&lang=js"
export * from "./Client.vue?vue&type=script&setup=true&lang=js"

import "./Client.vue?vue&type=style&index=0&id=14f615ba&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f615ba"]])

export default __exports__